import type { PictureSource } from "../engine/lessonTypes";
import { WorldThumbnail } from "./WorldThumbnail";

interface PictureContentProps {
  source: PictureSource;
  alt?: string;
}

/**
 * Renders one picture-lesson item. World-backed pictures reuse the live canvas
 * renderer (via `WorldThumbnail`); string sources are static image URLs kept
 * for custom lessons.
 */
export function PictureContent({ source, alt }: PictureContentProps) {
  if (typeof source === "string") {
    return <img src={source} alt={alt ?? ""} />;
  }
  return <WorldThumbnail world={source.world} label={alt} />;
}
